import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { MentorMappingFormDataService } from "common/services/data-services/admin/mentor/mentor-map-form-data.service";
import { MentorMappingListDataService } from "common/services/data-services/custom-service/mentor-list-service";
import { MentorBatchListDataService } from "common/services/data-services/custom-service/mentor-batch-service";
import { MentorMappingMetaModel } from "common/models/page-models/mentor-mapping/mentor-mapping-meta-model";
import { MentorMappingModel } from "common/models/page-models/mentor-mapping/mentor-mapping-model";
import { BranchesGridDataService } from "common/services/data-services/admin/branches/branches-grid-data.service";
import { GroupsGridDataService } from "common/services/data-services/admin/groups/groups-grid-data.service";
import { StudentsGridDataService } from "common/services/data-services/admin/students/students-grid-data.service";
import { BatchListDataService } from "common/services/data-services/custom-service/batch-service";

@Injectable({
    providedIn: 'root'
})

export class  MentorMappingFormWidgetService extends FormWidgetService<MentorMappingModel> {
    studentList: any = [];
    groupList: any = [];
    batchList: any = [];
    constructor(protected ds: MentorMappingFormDataService, private mentorListService: MentorMappingListDataService, private batchListService: BatchListDataService, private branchListService: BranchesGridDataService, private groupListService: GroupsGridDataService, private studentService: StudentsGridDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new MentorMappingMetaModel();
        return meta.getMetaModel();
    }

  
    override prepareMetaModel(dataModel: MentorMappingModel, metaModel: MentorMappingMetaModel, routeData: WidgetModel, event: any = null): Promise<MentorMappingMetaModel> {
        return new Promise<MentorMappingMetaModel>((resolve, reject) => {
            if(event !== null){
            //    console.log(dataModel,this.groupList,'====');
               
                const region = ['east', 'west', 'north', 'south']
                if(event.field_Name=== 'batch_id'){
                    metaModel.properties['group_id'].options = this.groupList.filter((group) => group.batch_id === dataModel.batch_id);
                    // console.log(metaModel.properties['group_id'].options);
                    
                    const batchName = metaModel.properties['batch_id'].options.filter((batch) => batch.id === dataModel.batch_id)[0].batch_number;
                    metaModel.properties['student_ids'].options = this.studentList.filter((student) => student.batch_name === batchName);

                } else if (event.field_Name === 'group_id') {
                    // console.log(dataModel,dataModel.group_id,this.studentList);
                    
                    // metaModel.properties['student_ids'].options = this.studentList.filter((student) =>
                    //      student.group.includes(dataModel.group_id));

                    metaModel.properties['student_ids'].options = this.studentList.filter((student) => 
                        student.group.some(group => group.group_id === dataModel.group_id)
                    );

                } else if (event.field_Name === 'branch_id') {
                    const branchName = metaModel.properties['branch_id'].options.filter((branch) => branch.id === dataModel.branch_id)[0].department_name;
                    metaModel.properties['student_ids'].options = this.studentList.filter((student) => student.branch_name === branchName);
                } 
                // else if (region.includes(event.field_Name)) {
                //     const region = event.field_Name;
                //     console.log(region, dataModel[region]);
                //     if(dataModel[region] === true) {
                //         metaModel.properties['student_ids'].options = metaModel.properties['student_ids'].options.filter((student) => student.region === region);
                //         console.log(metaModel.properties['student_ids'].options)
                //     } else {
                //         const options = metaModel.properties['student_ids'].options.filter((student) => student.region !== region);
                //         metaModel.properties['student_ids'].options = [...options, ...metaModel.properties['student_ids'].options]
                //     }
                // }
            } else {
                this.mentorListService.postData('').then((data) => {
                    metaModel.properties['mentorId'].options = data.details;
                });
                this.batchListService.postData('').then((data) => {
                    this.batchList = data.details;
                    metaModel.properties['batch_id'].options = data.details;
                });
                this.branchListService.postData('').then((data) => {
                    metaModel.properties['branch_id'].options = data.details;
                })
                this.groupListService.postData('').then((data) => {
                    this.groupList = data.details;
                    metaModel.properties['group_id'].options = data.details;
                });
                this.studentService.postData('').then((data) => {
                    this.studentList = data.details.filter((student) => student.status === 1 || student.status === 3);
                    metaModel.properties['student_ids'].options = data.details.filter((student) => student.status === 1 || student.status === 3);
                });
            }
            resolve(metaModel);
        });
    }
}
